import { useEffect } from 'react';
import { doc, getDoc, onSnapshot } from 'firebase/firestore';
import { db } from '../config/firebase';
import { useHatm } from '../context/HatmContext';

export function useHatmData(hatmId) {
  const { setState } = useHatm();

  useEffect(() => {
    if (!hatmId) return;

    const hatmRef = doc(db, "hatms", hatmId);

    const unsubscribe = onSnapshot(
      hatmRef,
      (snapshot) => {
        if (snapshot.exists()) {
          const hatmData = snapshot.data();
          const safeHatmData = {
            ...hatmData,
            juzs: hatmData.juzs || {}
          };
          
          const creatorRef = doc(db, "users", hatmData.creator);
          
          getDoc(creatorRef)
            .then((userDoc) => {
              if (userDoc.exists()) {
                setState({
                  ...safeHatmData,
                  creatorName: userDoc.data().fullName,
                });
              }
            })
            .catch((error) => {
              console.error("Error fetching creator data:", error);
              setState(safeHatmData);
            });
        } else {
          setState({ juzs: {} });
        }
      },
      (error) => {
        console.error("Error listening to hatm:", error);
        setState({ juzs: {} });
      }
    );

    return () => unsubscribe();
  }, [hatmId, setState]);
} 